import { ActionIcon, Box, Text } from '@mantine/core';
import EditIcon from '@/icons/edit.svg';
import { useHover } from '@mantine/hooks';

type DescriptionProps = {
  description: string;
  onClick?: () => void;
};

function injectLinkStyles(html: string): string {
  const style = 'color: blue; text-decoration: underline;';
  return html.replace(/<a /g, `<a style="${style}" `);
}

export function Description({ description, onClick, ...mantineHoverCardChildProps }: DescriptionProps) {
  const styledDescription = description ? injectLinkStyles(description) : null;
  const { hovered, ref } = useHover();

  return (
    <Box ref={ref} flex='1 0'>
      <Text size='sm' c='gray.6' {...mantineHoverCardChildProps}>
        {styledDescription ? (
          <span
            dangerouslySetInnerHTML={{
              __html: styledDescription,
            }}
          />
        ) : (
          'No description'
        )}
        <ActionIcon
          style={{
            backgroundColor: 'transparent',
            opacity: hovered ? 1 : 0,
          }}
          onClick={onClick}
        >
          <EditIcon />
        </ActionIcon>
      </Text>
    </Box>
  );
}
